// probaworkflow configs
import Configslayout from "@/layout/config_base_layout/ConfigsLayout.vue";
import GlobalOverview from "@/views/config_views/GlobalOverview/GlobalOverview.vue";
import ProjectManagement from "@/views/config_views/ProjectManagement/ProjectManagement.vue";
import UserManagement from "@/views/config_views/UserManagement/UserManagement.vue";
import RolesManagement from "@/views/config_views/RolesManagement/ManageRole.vue";
import EntityConfigs from "@/views/config_views/EntityConfigs/EntityConfigs.vue";
import EntityConfigDetail from "@/views/config_views/EntityConfigDetail/EntityConfigDetail.vue";
import EntitySubsystemBindings from "@/views/config_views/EntitySubsystemBindings/EntitySubsystemBindings.vue";
import CreateForm from "@/views/config_views/FormManagement/CreateForm/CreateForm.vue";
import CreateSections from "@/views/config_views/FormManagement/FormBuilder/create_sections/CreateSections.vue";
import ManageQuestions from "@/views/config_views/FormManagement/FormBuilder/manage_questions/ManageQuestions.vue";
import PreviewForm from "@/views/config_views/FormManagement/PreviewForm/PreviewForm.vue";
import ViewTemplate from "@/views/config_views/TemplateManagement/ViewTemplates/ViewTemplate.vue"
import UploadTemplate from "@/views/config_views/TemplateManagement/UploadTemplate/UploadTemplate.vue"
import CreateWorkflow from "@/views/config_views/WorkflowManagement/CreateWorkflow/CreateWorkflow.vue";
import ConfigureWorkflow from "@/views/config_views/WorkflowManagement/ConfigureWorkflow/ConfigureWorkflow.vue";
import ManageStatus from "@/views/config_views/StatusManagement/ManageStatus.vue";
import CreateRiskFramework from "@/views/config_views/RiskManagement/CreateFramework/CreateRiskFramework.vue";
import ComplianceManagement from "@/views/config_views/ComplianceManagement/ComplianceManagement.vue";
import DocumentsWorkflow from "@/views/config_views/TemplateManagement/Esigining/DocumentsWorkflow.vue";
import ManageSubEntities from "@/views/config_views/EntityManagement/ManageSubEntities/ManageSubEntities.vue";
import SubEntityRequirements from "@/views/config_views/EntityManagement/SubEntityRequirements/SubEntityRequirements.vue";
import ManageDocuments from "@/views/config_views/DocumentsManagement/ManageDocuments.vue";
import VerificationServices from "@/views/config_views/AutoVerificationManagment/VerificationServices/VerificationServices.vue";
import ConfigureVerificationServices from "@/views/config_views/AutoVerificationManagment/ConfigureVerificationServices/ConfigureVerificationServices.vue"
import VerificationForm from "@/views/config_views/AutoVerificationManagment/VerificationForm/VerificationForm.vue"
import FormQuestionMapping from "@/views/config_views/AutoVerificationManagment/FormQuestionMapping/FormQuestionMapping.vue"
import ConfigureVerificationForm from "@/views/config_views/AutoVerificationManagment/ConfigureVerificationForm/ConfigureVerificationForm.vue"
import ManualVerification from "@/views/config_views/ManualVerification/ManualVerification.vue"
import ManualVerificationBinding from "@/views/config_views/ManualVerification/ManualVerificationBinding/ManualVerificationBinding.vue"

const probaworkflows_routes = [{
    path: "/",
    name: "GlobalConfigsBase",
    component: Configslayout,

    children: [
        {
            path: "/overview",
            name: "GlobalOverview",
            component: GlobalOverview
        },
        {
            path: "/projects",
            name: "ProjectManagement",
            component: ProjectManagement,
        },
        {
            path: "/users",
            name: "UserManagement",
            component: UserManagement,
        },
        {
            path: "/roles",
            name: "RolesManagement",
            component: RolesManagement,
        },
        {
            path: "/entity-configs",
            name: "EntityConfigs",
            component: EntityConfigs
        },
        {
            path: "/entity-configs/:entityTypeId",
            name: "EntityConfigDetail",
            component: EntityConfigDetail
        },
        {
            path: "/entity-configs/:entityTypeId/bind-subsystems",
            name: "EntitySubsystemBindings",
            component: EntitySubsystemBindings
        },
        // Form Management Hub
        {
            path: "/create_form",
            name: "CreateForm",
            component: CreateForm
        },
        {
            path: "/create_sections",
            name: "CreateSections",
            component: CreateSections
        },
        {
            path: "/manage_questions",
            name: "ManageQuestions",
            component: ManageQuestions,
        },
        {
            path: "/preview_form",
            name: "PreviewForm",
            component: PreviewForm
        },
        {
            path: "/view_template",
            name: "ViewTemplate",
            component: ViewTemplate
        },
        {
            path: "/upload_template",
            name: "UploadTemplate",
            component: UploadTemplate
        },
        {
            path: "/documents_workflow",
            name: "DocumentsWorkflow",
            component: DocumentsWorkflow
        },

        // Workflow Management Hub
        {
            path: "/create_workflow",
            name: "CreateWorkflow",
            component: CreateWorkflow
        },
        {
            path: "/configure_workflow",
            name: "ConfigureWorkflow",
            component: ConfigureWorkflow
        },

        // Manage Documents
        {
            path: "/documents",
            name: "ManageDocuments",
            component: ManageDocuments
        },

        // Child Entities
        {
            path: "/manage_sub_entity",
            name: "ManageSubEntities",
            component: ManageSubEntities
        },
        {
            path: "/sub_entity_requirements",
            name: "SubEntityRequirements",
            component: SubEntityRequirements
        },

        // Status Management Hub
        {
            path: "/manage_status",
            name: "ManageStatus",
            component: ManageStatus
        },
        {
            path: "/compliance_management",
            name: "ComplianceManagement",
            component: ComplianceManagement
        },
        {
            path: "/verification_services",
            name: "VerificationServices",
            component: VerificationServices
        },
        // Risk Management Hub
        {
            path: "/create_riskframework",
            name: "CreateRiskFramework",
            component: CreateRiskFramework
        },
        {
            path: "/configure_verification_services",
            name: "ConfigureVerificationServices",
            component: ConfigureVerificationServices
        },
        {
            path: "/configure_verification_form",
            name: "ConfigureVerificationForm",
            component: ConfigureVerificationForm
        },
        {
            path: "/verification_form",
            name: "VerificationForm",
            component: VerificationForm
        },
        {
            path: "/form_question_mapping",
            name: "FormQuestionMapping",
            component: FormQuestionMapping
        },
        {
            path: "/manual_verification",
            name: "ManualVerification",
            component: ManualVerification
        },
        {
            path: "/manual_verification_binding",
            name: "ManualVerificationBinding",
            component: ManualVerificationBinding
        },
    ]

   }
]



export default probaworkflows_routes;
